// Canonical product category vocabulary. See
// backend/utils/categories.py for the mirror on the server; the two
// lists are kept in sync by hand (they change rarely). The marketplace
// filter adds "all" at the top for the "show everything" case.
//
// Slugs are lowercase and stable; translate on display via
// `t('products.categories.<slug>')` (or
// `t('marketplace.categories.<slug>')` for the filter chip).
export const CATEGORY_SLUGS = [
  'insecticide',
  'herbicide',
  'fungicide',
  'fertilizer',
  'seed',
  'veterinary_drug',
  'vaccine',
  'equipment',
  'other',
];

// Marketplace filter list — same slugs with an "all" sentinel the
// SelectValue starts on.
export const MARKETPLACE_FILTER_SLUGS = ['all', ...CATEGORY_SLUGS];

/**
 * Price helpers.
 *
 * Marketplace rows arrive from the backend with `base_price` (the DB
 * column). Some older code paths used `price`. Rather than chase every
 * caller, this helper is the one place that resolves the fallback —
 * use it anywhere a price is rendered or compared.
 */
export function productPrice(product) {
  if (!product) return undefined;
  if (typeof product.price === 'number') return product.price;
  if (typeof product.base_price === 'number') return product.base_price;
  return undefined;
}

/** True when there's a real price to show. base_price is NOT NULL in the
 *  database and defaults to 0, so 0 means "no price set", not "free". */
export function hasPrice(product) {
  const value = productPrice(product);
  return typeof value === 'number' && !Number.isNaN(value) && value > 0;
}

/** Format a price in ₦. Returns the empty-state label when missing. */
export function formatPriceNaira(product, emptyLabel = 'N/A') {
  if (!hasPrice(product)) return emptyLabel;
  return `₦${productPrice(product).toLocaleString()}`;
}
